import {
  useState,
  useEffect,
  useCallback
} from "react";
import PropTypes from "prop-types";

import { useSelector } from "react-redux";
import { dispatch } from "../../../../state/store";
import { setChartFilters } from "../../../../state/ducks";

import { dashboardTabs } from "../../../../consts";
import { deviceUtil } from "../../../../utils";

import { TabsSelector } from "../../../../components";

const DeviceTabsSelector = ({ id, onUpdateChartData }) => {
  const device = useSelector((store) => store.dashboardFilters.device);

  const [activeTab, setActiveTab] = useState(dashboardTabs[0].id);
  const [duoDevice, setDuoDevice] = useState(null);

  const onSelectTab = useCallback(
    (tabId) => {
      if (duoDevice?.length === 3) {
        const filter =
          tabId === dashboardTabs[0].id
            ? [duoDevice[0]]
            : tabId === dashboardTabs[1].id
              ? [duoDevice[1]]
              : [duoDevice[2]];

        dispatch(setChartFilters(id, filter.id));
        onUpdateChartData(filter);
      }
    },
    [duoDevice]
  );

  useEffect(() => {
    if (device?.id !== 0 && device?.value) {
      const deviceGroup = deviceUtil.getDeviceGroupByName(device.value);

      let duo = null;

      if (deviceGroup === "duoDevices") {
        const deviceTypes = deviceUtil.getDeviceTypesByName(device.value);

        if (deviceTypes?.length === 3) {
          duo = deviceTypes;
        }
      }

      setDuoDevice(duo);
    } else {
      setDuoDevice(null);
    }
  }, [device]);

  useEffect(() => {
    onSelectTab(activeTab);
  }, [activeTab]);

  const handleSelectTab = (selectedId) => {
    setActiveTab(selectedId);
  };

  return (
    duoDevice
      ? <TabsSelector tabs={dashboardTabs} activeTab={activeTab} onSelectTab={handleSelectTab} />
      : <></>
  )
};

DeviceTabsSelector.propTypes = {
  onUpdateChartData: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired
};

export default DeviceTabsSelector;
